import { usePermission as useLibPermission } from '@hwm/ui-lib';
import { PermissionsEnum } from '@shared/models';

export const usePermissions = () => {
  const { hasPermission } = useLibPermission();

  return {
    canEditOrCreate: hasPermission(PermissionsEnum.CanEditAcc),
    canUpdateCallIn: hasPermission(PermissionsEnum.CanUpdateCallIn),
    canSubmitPMZSettings: hasPermission(PermissionsEnum.CanSubmitPMZSettings),
    canEditSites: hasPermission(PermissionsEnum.CanEditSites),
  };
};
